import { prepareSortedOptions } from '../../prepareOptions';
import {
  ELECTRIC_SEAT_ADJUSTMENT,
  SPORTS_SEATS,
  HAS_LUMBAR_SUPPORT,
  HAS_MASSAGE_SEATS,
  HAS_SEAT_VENTILATION,
} from './values';

export default prepareSortedOptions([
  {
    value: ELECTRIC_SEAT_ADJUSTMENT,
    label: __('carDetails.equipmentGroups.seatSettings'),
  },
  {
    value: SPORTS_SEATS,
    label: __('carDetails.equipmentGroups.sportsSeats'),
  },
  {
    value: HAS_LUMBAR_SUPPORT,
    label: __('carDetails.features.hasLumbarSupport'),
  },
  {
    value: HAS_MASSAGE_SEATS,
    label: __('carDetails.features.hasMassageSeats'),
  },
  {
    value: HAS_SEAT_VENTILATION,
    label: __('carDetails.features.hasSeatVentilation'),
  },
]);
